import { Alert, AlertDescription, AlertIcon, Box, Link } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { urls } from "../../../../urls";

export const OwnProcurementNotice = ({ event }: { event: Pick<PortalSourcingEventDetailDto, "id"> }) => {
  const { t } = useTranslation();
  return (
    <Alert status="info" variant="subtle" rounded="md">
      <AlertIcon />
      <Box>
        <AlertDescription display="block">
          {t("This is your organization's own procurement, so you can neither register interest in it nor deliver a bid.")}
        </AlertDescription>
        <AlertDescription display="block">
          <Link as={RouterLink} to={urls.app.sourcingEvents.view.go(event.id)} color="smPrimary">
            {t("Open the procurement")}
          </Link>
        </AlertDescription>
      </Box>
    </Alert>
  );
};
